const initialState = {
    lofRegForm: "",
    lofRegWidgetError: undefined,
    oloid: "",
    oloidiframe: "",
    transactionToken: "",
    clientCsrfToken: "",
    lofUserName: "",
    lofUserNameAvailable: "",
    lofUserNameError: "",
    lofUserNameErrorMsg: "",
    lofPwd: "",
    lofPwdError: "",
    lofPwdErrorMSg: "",
    lofPwdStrength: "",
    lofRePwd: "",
    lofRePwdError: "",    
    lofMON: "",
    myVzSilentLogin: ""
};

function lofRegistration(state = initialState, action) {
    switch (action.type) {
        case 'SET_LOF_REGISTRATION_FORM':
            return Object.assign({}, state, {
                lofRegForm: action.value
            })
        case 'SET_LOF_REGISTRATION_WIDGET_ERROR':
            return Object.assign({}, state, {
                lofRegWidgetError: action.value
            })            
        case 'SET_OLOID':    
            return Object.assign({}, state, {
                oloid: action.value
            })
        case 'SET_OLOID_IFRAME':    
            return Object.assign({}, state, {
                oloidiframe: action.value
            })            
        case 'SET_TRANSACTION_TOKEN':    
            return Object.assign({}, state, {
                transactionToken: action.value
            })
        case 'SET_CLIENT_CSRF_TOKEN':    
            return Object.assign({}, state, {
                clientCsrfToken: action.value
            })
        case 'SET_LOF_USERNAME':    
            return Object.assign({}, state, {
                lofUserName: action.value
            })
        case 'SET_LOF_USERNAME_ERROR':    
            return Object.assign({}, state, {
                lofUserNameError: action.value
            })            
        case 'SET_LOF_USERNAME_ERROR_MSG':    
            return Object.assign({}, state, {
                lofUserNameErrorMsg: action.value
            })
        case 'SET_LOF_USERNAME_AVAILABILITY':    
            return Object.assign({}, state, {
                lofUserNameAvailable: action.value
            })                                                                          
        case 'SET_LOF_PWD':    
            return Object.assign({}, state, {
                lofPwd: action.value
            })
        case 'SET_LOF_PWD_ERROR':    
            return Object.assign({}, state, {
                lofPwdError: action.value
            })            
        case 'SET_LOF_PWD_ERROR_MSG':    
            return Object.assign({}, state, {
                lofPwdErrorMsg: action.value
            })
        case 'SET_LOF_PWD_STRENGTH':    
            return Object.assign({}, state, {
                lofPwdStrength: action.value
            })
        case 'SET_LOF_REPWD':    
            return Object.assign({}, state, {
                lofRePwd: action.value
            })
        case 'SET_LOF_REPWD_ERROR':    
            return Object.assign({}, state, {
                lofRePwdError: action.value
            })
        case 'SET_LOF_REPWD_ERROR_MSG':    
            return Object.assign({}, state, {
                lofRePwdErrorMsg: action.value
            })                                             
        case 'SET_LOF_MON':    
            return Object.assign({}, state, {
                lofMON: action.value
            })
        case 'SET_MYVZ_SILENT_LOGIN':    
            return Object.assign({}, state, {
                myVzSilentLogin: action.value
            })            
        default:
            return state            
    }

}

export default lofRegistration;